import { asText } from '@prismicio/helpers';
import camelcaseKeys from 'camelcase-keys';

export function transformProperties(rawData) {
  return camelcaseKeys(rawData, { deep: true, exclude: ['link_type', '_meta'] });
}

export function optimizeImage(url, width, quality = 85) {
  if (/\.svg$/.test(url)) {
    return url;
  }
  return `${url}&w=${width}&q=${quality}`;
}

export function prismicFieldHasContent(field) {
  let fieldValue = field || '';
  if (Array.isArray(field)) {
    fieldValue = asText(field);
  }
  return fieldValue.trim().length > 0;
}

export const fieldHasContent = prismicFieldHasContent;

export function getFieldContent(field) {
  if (Array.isArray(field)) {
    return asText(field);
  }
  return field;
}

export function groupFieldHasContent(field = [], referenceField) {
  return (
    (field || [])
      .map(({ [referenceField]: referenceFieldValue }) => getFieldContent(referenceFieldValue))
      .join('')
      .trim().length > 0
  );
}
